// Global app CSS (P39) — standalone module for the tiny entry chunk.
const G = `
/* Font families load from index.html as a preconnected stylesheet with
   font-display:swap (P40) — the old CSS @import here fetched them late. */

/* P40 — images fade in over their container's placeholder tint (150ms); the
   container's fixed aspect/height means photos arriving never shift layout. */
.op-img-fade{opacity:0;transition:opacity 150ms ease;}
.op-img-fade.op-img-in{opacity:1;}

/* P40 — immediate pressed feedback on every tappable control */
button:active,[role="button"]:active,.op-cat-btn:active,.shr-pill:active,.shr-card-btn:active{transform:scale(0.985);}
button{touch-action:manipulation;}
:root{
  /* Cream/charcoal/gold palette — migrated from dark theme.
     Existing var names preserved for backward compat across hundreds of inline styles. */
  --pr:#B08D2E;                       /* gold accent (was #C9A84C) */
  --gr:#1A3A2E;                       /* success / CTA dark green (was #6AC7A6) */
  --bg:#F8F4ED;                       /* page background cream (was #030F1C) */
  --bgc:#FAFAF8;                      /* elevated card cream (was #071A0F) */
  --bo:rgba(0,0,0,0.12);              /* solid hairline (was #8B6914) */
  --bof:rgba(0,0,0,0.08);             /* faint hairline (was rgba(139,105,20,0.4)) */
  --tx:#2A2A2A;                       /* primary charcoal text (was #F5F0E8) */
  --txm:rgba(42,42,42,0.7);           /* secondary text (was #B8A878) */
  --txd:rgba(42,42,42,0.55);          /* tertiary text (was #5A4A2A) */
  /* Spec tokens (new) */
  --op-bg:#F8F4ED;
  --op-bg-elevated:#FAFAF8;
  --op-bg-section:#F3EFE6;
  --op-text-primary:#2A2A2A;
  --op-text-secondary:rgba(42,42,42,0.7);
  --op-text-tertiary:rgba(42,42,42,0.55);
  --op-accent:#B08D2E;
  --op-accent-soft:rgba(176,141,46,0.15);
  --op-text-accent:#1A3A2E;          /* dark green — used wherever gold was previously a text color */
  --op-cta:#1A3A2E;
  --op-cta-text:#F8F4ED;
  --op-hairline:rgba(0,0,0,0.08);
  --op-success:#1A3A2E;
  --op-warning:#B08D2E;
  --op-danger:#B43028;
}
*{box-sizing:border-box;margin:0;padding:0;text-transform:uppercase;letter-spacing:0.06em;}
html,body{font-family:'Jost',sans-serif;font-weight:300;font-size:13px;background:var(--bg);color:var(--tx);min-height:100vh;text-transform:uppercase;letter-spacing:0.06em;}
input,select,textarea,button{font-family:'Jost',sans-serif;text-transform:uppercase;letter-spacing:0.06em;}
::placeholder{text-transform:uppercase;letter-spacing:0.06em;}
input[type=range]{-webkit-appearance:none;appearance:none;width:100%;height:1px;background:var(--bo);border-radius:0;outline:none;cursor:pointer;}
input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;width:12px;height:12px;border-radius:2px;background:var(--pr);cursor:pointer;border:1px solid var(--bg);}
input[type=range]::-moz-range-thumb{width:12px;height:12px;border-radius:2px;background:var(--pr);cursor:pointer;border:1px solid var(--bg);}
::-webkit-scrollbar{width:6px;}
::-webkit-scrollbar-track{background:transparent;}
::-webkit-scrollbar-thumb{background:rgba(176,141,46,0.45);border-radius:3px;}
::-webkit-scrollbar-thumb:hover{background:var(--pr);}
::selection{background:rgba(201,168,76,0.18);}
.btn-g{background:transparent;color:var(--op-text-accent);border:1px solid var(--pr);border-radius:4px;padding:10px 24px;font-size:13px;font-weight:400;letter-spacing:0.15em;text-transform:uppercase;cursor:pointer;transition:background 0.18s,color 0.18s;font-family:'Jost',sans-serif;}
.btn-g:hover:not(:disabled){background:var(--pr)!important;color:var(--bg)!important;}
.btn-g:disabled{opacity:0.35;cursor:not-allowed;}
.btn-gf{background:var(--pr);color:var(--bg);border:1px solid var(--pr);border-radius:4px;padding:10px 24px;font-size:13px;font-weight:500;letter-spacing:0.15em;text-transform:uppercase;cursor:pointer;transition:background 0.18s,color 0.18s;font-family:'Jost',sans-serif;}
.btn-gf:hover:not(:disabled){background:transparent!important;color:var(--op-text-accent)!important;}
.btn-gf:disabled{opacity:0.35;cursor:not-allowed;}
.btn-red{background:transparent;color:#E05C4A;border:1px solid rgba(192,57,43,0.45);border-radius:4px;padding:10px 18px;font-size:13px;letter-spacing:0.1em;cursor:pointer;transition:background 0.18s;font-family:'Jost',sans-serif;}
.btn-red:hover:not(:disabled){background:rgba(192,57,43,0.08)!important;}
@keyframes fadeInCard{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
.lux-card{animation:fadeInCard 0.38s ease both;transition:border-color 0.22s;}
.lux-card:nth-child(1){animation-delay:.04s}.lux-card:nth-child(2){animation-delay:.08s}.lux-card:nth-child(3){animation-delay:.12s}.lux-card:nth-child(4){animation-delay:.16s}.lux-card:nth-child(5){animation-delay:.20s}.lux-card:nth-child(6){animation-delay:.24s}
.lux-card:hover{border-color:var(--op-text-accent)!important;}
.section-head{font-family:'Cormorant Garamond',serif!important;font-style:normal!important;font-weight:300!important;color:var(--op-text-accent)!important;letter-spacing:0.1em!important;text-transform:uppercase!important;position:relative;padding-bottom:12px!important;}
.section-head::after{content:'';position:absolute;bottom:0;left:0;width:36px;height:1px;background:rgba(176,141,46,0.3);}
.section-head.dash::after{width:60px;}
.op-dash-btn{display:inline-flex;align-items:center;justify-content:center;padding:10px 18px;background:transparent;color:var(--op-cta);border:1px solid var(--op-cta);border-radius:4px;font-family:'Inter',sans-serif;font-size:13px;font-weight:600;letter-spacing:0.25em;text-transform:uppercase;cursor:pointer;transition:background 0.2s ease, color 0.2s ease;line-height:1;}
.op-dash-btn:hover{background:var(--op-cta);color:var(--op-cta-text);}
/* Catalogue card buttons — consistent across +Add to Offer / Edit / Delete / In Offer */
.op-cat-btn{display:inline-flex;align-items:center;justify-content:center;padding:10px 16px;font-family:'Inter',sans-serif;font-size:13px;font-weight:600;letter-spacing:0.25em;text-transform:uppercase;cursor:pointer;border-radius:3px;transition:background 0.2s ease, color 0.2s ease, border-color 0.2s ease;line-height:1;min-height:40px;}
.op-cat-btn-primary{background:var(--op-cta);color:var(--op-cta-text);border:1px solid var(--op-cta);}
.op-cat-btn-primary:hover{background:transparent;color:var(--op-cta);}
.op-cat-btn-outline{background:transparent;color:var(--op-cta);border:1px solid var(--op-cta);}
.op-cat-btn-outline:hover{background:var(--op-cta);color:var(--op-cta-text);}
/* Catalogue filter pills */
.op-cat-pill{padding:8px 16px;border-radius:3px;font-family:'Inter',sans-serif;font-size:13px;font-weight:600;letter-spacing:0.25em;text-transform:uppercase;cursor:pointer;transition:background 0.2s ease, color 0.2s ease;line-height:1;min-height:36px;display:inline-flex;align-items:center;justify-content:center;}
.op-cat-pill-active{background:var(--op-cta);color:var(--op-cta-text);border:1px solid var(--op-cta);}
.op-cat-pill-inactive{background:transparent;color:var(--op-cta);border:1px solid var(--op-cta);}
.op-cat-pill-inactive:hover{background:rgba(26,58,46,0.06);}
.nav-tab-active{position:relative;}
.nav-tab-active::after{content:'';position:absolute;bottom:-1px;left:0;right:0;height:1px;background:var(--pr);}

/* ─── Responsive foundations (Task 3 P1) ──────────────────────────────────
   Cascade across the whole admin app so individual pages don't need to
   re-implement touch sizing, iOS zoom prevention, focus rings, etc. */
html,body{min-width:0;-webkit-text-size-adjust:100%;}
body{overflow-x:hidden;}
img,video{max-width:100%;height:auto;}
*:focus-visible{outline:2px solid var(--pr);outline-offset:2px;border-radius:3px;}
input:focus-visible,textarea:focus-visible,select:focus-visible{outline:2px solid var(--pr);outline-offset:0;box-shadow:0 0 0 3px rgba(176,141,46,0.18);}
/* Tablet — wrap nav tabs to two lines if needed */
@media(max-width:1024px){
  .op-nav-tabs-row{flex-wrap:wrap!important;row-gap:0;}
}
/* Mobile — touch sizing, iOS zoom prevention, padding shrink */
@media(max-width:768px){
  html,body{font-size:13px;}
  input,select,textarea{font-size:16px!important;min-height:48px;padding:12px 14px;}
  input[type=checkbox],input[type=radio],input[type=range],input[type=color]{min-height:auto;padding:0;}
  button,.btn-g,.btn-gf,.btn-red,.op-dash-btn,.op-cat-btn{min-height:48px;padding:12px 18px;}
  button.icon-only,button[aria-label*="close" i],button[aria-label*="remove" i]{padding:8px;min-width:48px;}
  /* Page-level container padding shrink */
  .op-page,.op-section,main{padding-left:14px!important;padding-right:14px!important;}
  /* Responsive grids — generic fall-backs.
     Pages with inline grid-template-columns get explicit !important to win. */
  .op-stat-grid{grid-template-columns:repeat(2,1fr)!important;}
  .op-card-grid,.op-product-grid{grid-template-columns:1fr!important;}
  .op-form-row,.op-form-grid{grid-template-columns:1fr!important;display:flex!important;flex-direction:column!important;gap:14px!important;}
  .op-action-row{flex-wrap:wrap;gap:8px;}
  .op-action-row > *{flex:1 1 calc(50% - 4px);}
  /* (Quick Actions row layout lives in the P20 density block further down.) */
  /* Tables — wrap natively rendered tables so they scroll horizontally
     rather than blowing out the layout. */
  table{display:block;overflow-x:auto;-webkit-overflow-scrolling:touch;max-width:100%;}
  .op-table-stack thead{display:none;}
  .op-table-stack tr{display:block;border:1px solid var(--bo);border-radius:6px;padding:12px;margin-bottom:10px;background:var(--bgc);}
  .op-table-stack td{display:flex;justify-content:space-between;padding:6px 0;border:none;font-size:13px;}
  .op-table-stack td::before{content:attr(data-label);font-weight:600;color:var(--txm);margin-right:12px;text-transform:uppercase;letter-spacing:0.08em;font-size:11px;}
  /* Modal full-screen on mobile — opt-in via .op-modal-mobile-full */
  .op-modal-mobile-full{position:fixed!important;inset:0!important;width:100vw!important;height:100vh!important;max-width:none!important;max-height:none!important;border-radius:0!important;margin:0!important;overflow-y:auto;}
}
@media(max-width:640px){
  html,body{font-size:12px;}
  .btn-g,.btn-gf,.btn-red{font-size:12px;}
}

/* ─── Admin mobile nav drawer (Task 3 P2) ──────────────────────────────── */
.op-mobile-nav{display:none;}
.op-hamburger{background:transparent;border:none;cursor:pointer;padding:10px;width:44px;height:44px;display:flex;align-items:center;justify-content:center;color:var(--op-text-accent);}
.op-hamburger svg{width:24px;height:24px;}
.op-mobile-page-name{font-family:'Playfair Display',serif;font-size:18px;font-weight:600;color:var(--op-text-accent);margin-left:8px;letter-spacing:0.04em;text-transform:none;}
.op-drawer-backdrop{position:fixed;inset:0;background:rgba(10,36,22,0.55);z-index:300;opacity:0;pointer-events:none;transition:opacity .18s ease;}
.op-drawer-backdrop.open{opacity:1;pointer-events:auto;}
.op-drawer{position:fixed;top:0;left:0;bottom:0;width:280px;max-width:85vw;background:#0A2416;color:#FAF8F5;z-index:301;transform:translateX(-100%);transition:transform .22s ease;display:flex;flex-direction:column;box-shadow:8px 0 32px rgba(0,0,0,0.3);}
.op-drawer.open{transform:translateX(0);}
.op-drawer-head{padding:24px 20px 16px;border-bottom:1px solid rgba(201,168,76,0.2);display:flex;align-items:center;justify-content:space-between;}
.op-drawer-brand{font-family:'Playfair Display',serif;font-size:18px;font-weight:700;color:#C9A84C;letter-spacing:0.04em;text-transform:none;}
.op-drawer-close{background:transparent;border:none;color:#FAF8F5;cursor:pointer;width:44px;height:44px;display:flex;align-items:center;justify-content:center;font-size:24px;line-height:1;}
.op-drawer-tabs{flex:1;min-height:0;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;touch-action:pan-y;padding:8px 0;}
.op-drawer-tab{width:100%;text-align:left;background:transparent;border:none;color:#FAF8F5;padding:14px 24px;font-family:'Poppins','Inter',sans-serif;font-size:15px;font-weight:500;letter-spacing:0.02em;text-transform:none;cursor:pointer;display:flex;align-items:center;justify-content:space-between;min-height:52px;border-left:3px solid transparent;transition:background .15s,border-color .15s;}
.op-drawer-tab:hover{background:rgba(201,168,76,0.08);}
.op-drawer-tab.active{background:rgba(201,168,76,0.12);border-left-color:#C9A84C;color:#C9A84C;}
.op-drawer-tab-badge{background:#C9A84C;color:#0A2416;font-size:11px;padding:2px 8px;border-radius:10px;font-weight:700;letter-spacing:0.04em;}
.op-drawer-foot{padding:16px 20px;border-top:1px solid rgba(201,168,76,0.2);display:flex;flex-direction:column;gap:8px;}
.op-drawer-email{font-size:12px;color:rgba(250,248,245,0.7);font-family:'Poppins',sans-serif;letter-spacing:0;text-transform:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.op-drawer-signout{background:transparent;border:1px solid rgba(201,168,76,0.5);color:#C9A84C;padding:12px;border-radius:4px;font-family:'Poppins',sans-serif;font-size:14px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;cursor:pointer;min-height:48px;}
.op-drawer-signout:hover{background:rgba(201,168,76,0.12);}
.op-view-showroom{color:#C9A84C;text-decoration:none;font-family:'Jost',sans-serif;font-size:12px;font-weight:500;letter-spacing:0.18em;text-transform:uppercase;padding:6px 10px;border-radius:4px;white-space:nowrap;transition:color .15s,background .15s;display:inline-flex;align-items:center;}
.op-view-showroom:hover{color:#1A3A2E;background:rgba(201,168,76,0.12);}
.op-drawer-view-showroom{color:#C9A84C;text-decoration:none;font-family:'Poppins',sans-serif;font-size:13px;font-weight:600;letter-spacing:0.12em;text-transform:uppercase;padding:12px;border:1px solid rgba(201,168,76,0.3);border-radius:4px;text-align:center;display:flex;align-items:center;justify-content:center;min-height:48px;transition:background .15s,border-color .15s;}
.op-drawer-view-showroom:hover{background:rgba(201,168,76,0.08);border-color:rgba(201,168,76,0.6);}
.op-mobile-acct{display:flex;align-items:center;justify-content:center;width:36px;height:36px;border-radius:50%;background:#1A3A2E;color:#F8F4ED;border:none;cursor:pointer;font-family:'Poppins',sans-serif;font-size:15px;font-weight:600;text-transform:uppercase;flex-shrink:0;}

/* ─── P55/P56 Leads list table ────────────────────────────────────────────── */
/* Real table discipline on desktop: one shared column template so every row
   aligns (State shows short codes so Actions fits ONE line). Titled header
   row sticks below the sticky filter stack; subtle hover; below 860px rows
   degrade to the card-row pattern (flex-wrap) keeping the Actions, and the
   header hides (the mobile Select-all label takes over). */
.op-lead-row{display:grid;grid-template-columns:28px minmax(170px,1.3fr) minmax(150px,1.2fr) 136px 84px 60px 94px;gap:10px;align-items:center;padding:10px 12px;border-bottom:1px solid rgba(0,0,0,0.06);background:var(--bgc);min-height:46px;box-sizing:border-box;}
.op-lead-row:hover{background:rgba(26,58,46,0.035);}
.op-lead-row-open{cursor:pointer;}
.op-lead-row-open:focus-visible{outline:2px solid var(--op-text-accent);outline-offset:-2px;}
.op-lead-head{position:sticky;z-index:80;border-bottom:1px solid var(--bo);min-height:0;padding:8px 12px;}
.op-lead-head:hover{background:var(--bgc);}
.op-leads-selectall-mobile{display:none!important;}
@media(max-width:860px){
  .op-lead-row{display:flex;flex-wrap:wrap;gap:6px 10px;align-items:center;}
  .op-lead-head{display:none;}
  .op-leads-selectall-mobile{display:inline-flex!important;}
}

/* P57: announcement-email panel — controls stack above the preview on narrow screens. */
@media(max-width:900px){.op-announce-grid{grid-template-columns:1fr!important;}}

/* ─── P19 dynamics pass ───────────────────────────────────────────────────── */
/* Sticky filter bars — sit just below the sticky nav (68px desktop / 56px mobile). */
.op-sticky-filters{position:sticky;top:68px;z-index:90;background:var(--bg);padding-top:6px;margin-top:-6px;}
@media(max-width:768px){.op-sticky-filters{top:56px;}}
/* Hover/press feedback — additive lift on buttons + pills (cards already
   have border/shadow hover via .lux-card + inline handlers). */
.op-cat-btn,.op-cat-pill,.op-dash-btn{transition:background 0.15s ease,color 0.15s ease,border-color 0.15s ease,transform 0.15s ease,box-shadow 0.15s ease!important;}
.op-cat-btn:hover:not(:disabled),.op-dash-btn:hover{transform:translateY(-1px);box-shadow:0 2px 8px rgba(0,0,0,0.12);}
.op-cat-btn:active:not(:disabled),.op-cat-pill:active,.op-dash-btn:active{transform:translateY(0) scale(0.98);box-shadow:none;}
/* Skeleton loaders — shimmer placeholder blocks while first snapshot loads. */
.op-skel{position:relative;overflow:hidden;background:rgba(0,0,0,0.07);border-radius:4px;}
.op-skel::after{content:"";position:absolute;inset:0;transform:translateX(-100%);background:linear-gradient(90deg,transparent,rgba(255,255,255,0.55),transparent);animation:opSkelShimmer 1.2s infinite;}
@keyframes opSkelShimmer{100%{transform:translateX(100%);}}
.op-skel-card{background:#FAFAF8;border:1px solid rgba(0,0,0,0.10);border-radius:4px;overflow:hidden;min-height:420px;}
.op-skel-row{background:#FAFAF8;border:1px solid rgba(0,0,0,0.08);border-radius:4px;padding:20px 24px;}
/* Quick-search overlay (Ctrl/Cmd+K) */
.op-qs-backdrop{position:fixed;inset:0;background:rgba(10,36,22,0.45);backdrop-filter:blur(3px);z-index:5000;display:flex;align-items:flex-start;justify-content:center;padding:12vh 16px 16px;}
.op-qs-panel{background:#FAFAF8;border:1px solid rgba(0,0,0,0.12);border-radius:8px;box-shadow:0 12px 48px rgba(0,0,0,0.25);width:100%;max-width:560px;max-height:70vh;display:flex;flex-direction:column;overflow:hidden;}
.op-qs-input{border:none;outline:none;background:transparent;padding:18px 20px;font-size:16px;font-family:'Inter',sans-serif;color:var(--tx);border-bottom:1px solid rgba(0,0,0,0.10);}
.op-qs-results{flex:1 1 auto;min-height:0;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;touch-action:pan-y;padding:8px 0;}
.op-qs-group{font-size:11px;font-family:'Inter',sans-serif;font-weight:600;letter-spacing:0.25em;text-transform:uppercase;color:var(--op-text-accent);padding:10px 20px 4px;}
.op-qs-item{display:flex;align-items:center;gap:10px;width:100%;text-align:left;background:transparent;border:none;padding:10px 20px;cursor:pointer;font-family:'Inter',sans-serif;font-size:14px;color:var(--tx);min-height:44px;}
.op-qs-item:hover,.op-qs-item.active{background:rgba(176,141,46,0.10);}
.op-qs-sub{font-size:12px;color:var(--txd);margin-left:auto;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:45%;}
.op-qs-empty{padding:24px 20px;font-size:13px;color:var(--txd);font-style:italic;text-align:center;}
@media(max-width:768px){
  .op-nav-desktop{display:none!important;}
  .op-mobile-nav{display:flex!important;align-items:center;height:56px;padding:0 8px 0 4px;background:var(--bg);border-bottom:1px solid var(--bo);position:sticky;top:0;z-index:100;transition:transform .25s ease;}
  .op-mobile-nav.nav-hidden{transform:translateY(-100%);}
}

/* ─── Lightbox mobile close (P18 Fix 1) ─────────────────────────────────────
   48px touch target, white × on a dark circle, pushed clear of the notch /
   status bar via safe-area insets. The close button is always the LAST
   toolbar button in yet-another-react-lightbox, regardless of which plugins
   (download/zoom) precede it. Applied ≤1024px to cover phones + iPads. */
@media(max-width:1024px){
  .yarl__toolbar{padding-top:calc(env(safe-area-inset-top, 0px) + 8px);padding-right:calc(env(safe-area-inset-right, 0px) + 8px);}
  .yarl__toolbar .yarl__button:last-of-type{width:48px;height:48px;padding:10px;background:rgba(0,0,0,0.55);border-radius:50%;color:#fff;filter:none;margin-left:6px;}
  .yarl__toolbar .yarl__button:last-of-type svg{width:28px;height:28px;}
}

/* ─── Universal inline-style grid reflow (Tasks 3 P3-P5) ───────────────────
   Admin pages use inline grid-template-columns everywhere. These rules
   reach into the rendered style="" attribute and reflow on mobile so we
   don't need to JSX-edit every single grid in the codebase. */
@media(max-width:768px){
  /* 2-col grids → 1-col stack */
  div[style*="grid-template-columns: 1fr 1fr"],
  div[style*="grid-template-columns:1fr 1fr"]{
    grid-template-columns:1fr!important;gap:12px!important;
  }
  /* 3-col → 1-col */
  div[style*="grid-template-columns: repeat(3"],
  div[style*="grid-template-columns:repeat(3"]{
    grid-template-columns:1fr!important;gap:12px!important;
  }
  /* 4-col → 2-col */
  div[style*="grid-template-columns: repeat(4"],
  div[style*="grid-template-columns:repeat(4"]{
    grid-template-columns:repeat(2,1fr)!important;gap:10px!important;
  }
  /* 5-col → 2-col */
  div[style*="grid-template-columns: repeat(5"],
  div[style*="grid-template-columns:repeat(5"]{
    grid-template-columns:repeat(2,1fr)!important;gap:10px!important;
  }
  /* Sidebar + content (180px 1fr / 224px 1fr / 420px 1fr / 1fr 224px) → stack */
  div[style*="180px 1fr"],
  div[style*="224px 1fr"],
  div[style*="420px 1fr"],
  div[style*="1fr 224px"],
  div[style*="1fr 200px"],
  div[style*="1fr 240px 200px"],
  div[style*="1fr 180px"]{
    grid-template-columns:1fr!important;gap:14px!important;
  }
  /* Long custom table-row grids (e.g. "100px 1fr 180px 110px 140px 130px 130px")
     → stack rows visually so they don't blow the viewport */
  div[style*="100px 1fr"]{
    grid-template-columns:1fr!important;gap:8px!important;
  }
}

/* ─── Mobile bug fixes ────────────────────────────────────────────────────
   Bug 1 — Duplicate page heading: hamburger nav already labels the page,
           so in-page H1s are redundant. Hide them on <=768.
   Bug 2 — Card action buttons overflowing: reflow to 2-col grid on mobile.
   Bug 3 — Cards extending past viewport: guarantee no horizontal overflow
           inside .op-page and lock card widths to container. */
@media(max-width:768px){
  .op-page-title{display:none!important;}
  /* P61 C13: the Offers heading carries the live count ("Offers N total"),
     so unlike other page titles it must stay visible on phones — compact. */
  .op-page-title.op-offers-title{display:block!important;font-size:20px!important;}
  /* Card action button row → 2-col grid, each cell full-width 48px */
  .op-card-actions{
    display:grid!important;grid-template-columns:repeat(2,1fr)!important;
    gap:8px!important;width:100%!important;justify-content:stretch!important;
    margin-top:8px;
  }
  .op-card-actions > *{
    width:100%!important;min-width:0!important;min-height:48px!important;
    padding:10px 8px!important;font-size:11px!important;white-space:normal!important;
    letter-spacing:0.12em!important;
  }
  /* Snooze dropdown wrapper is a grid cell — stretch its inner button to fill */
  .op-card-actions [data-snooze-menu]{display:block!important;padding:0!important;}
  .op-card-actions [data-snooze-menu] > .op-dash-btn{width:100%!important;min-height:48px!important;font-size:11px!important;}

  /* ── P20 Home density (Fix 3) ─────────────────────────────────────────── */
  /* Hero: compact — small logo, 22px single-line title, no subtitle/divider,
     total height ≤120px. */
  .op-home-hero{padding:16px 16px 14px!important;}
  .op-home-hero-logo{margin-bottom:6px!important;}
  .op-home-hero-logo img{height:48px!important;}
  .op-home-hero-title{font-size:22px!important;margin-bottom:0!important;letter-spacing:0.08em!important;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
  .op-home-hero-sub{display:none!important;}
  .op-home-hero-divider{display:none!important;}
  /* Stat cards: compact 2×2 — padding 14, number 28, label 11 */
  .op-home-body{padding-top:16px!important;}
  .op-stat-grid{gap:10px!important;margin-bottom:18px!important;}
  .op-stat-grid > .lux-card{padding:14px!important;}
  .op-stat-grid > .lux-card > div:nth-child(1){font-size:11px!important;margin-bottom:6px!important;letter-spacing:0.15em!important;}
  .op-stat-grid > .lux-card > div:nth-child(2){font-size:28px!important;}
  .op-stat-grid > .lux-card > div:nth-child(3){font-size:10px!important;margin-top:6px!important;letter-spacing:0.1em!important;}
  /* Section spacing: halve vertical gaps between Home sections */
  .op-reminder-section{margin-bottom:16px!important;}
  .op-quick-actions-wrap{padding-bottom:24px!important;gap:12px!important;}
  /* Quick Actions: single row of 3 compact 44px buttons (wraps if needed).
     min-width:max-content + 12px side padding so labels never touch borders. */
  .op-quick-actions{flex-direction:row!important;flex-wrap:wrap;gap:8px!important;}
  .op-quick-actions > *{flex:1 1 30%!important;width:auto!important;min-width:max-content!important;min-height:44px!important;padding:10px 12px!important;font-size:11px!important;letter-spacing:0.08em!important;text-align:center;justify-content:center!important;white-space:nowrap;}
  /* Page wrapper containment — no horizontal scroll, cards stay inside.
     P61 C13: overflow-x:hidden made .op-page a SCROLL CONTAINER, so the
     offers sticky bar stuck inside it — permanently shifted down over the
     first card on phones. overflow-x:clip clips without creating a scroll
     container (the hidden line stays as a fallback for old browsers). */
  .op-page{max-width:100%!important;overflow-x:hidden;overflow-x:clip;padding-left:14px!important;padding-right:14px!important;}
  .op-page > *{max-width:100%;}
}

/* ─── P62 C2: Product Inquiries rows → cards below 600px ──────────────────
   The 8-column grid is unreadable on phones: the header hides, each row
   becomes a card showing date, name, company, products, status and the
   offer chip; email/phone/message stay in the detail view. */
@media(max-width:600px){
  .op-inq-head{display:none!important;}
  .op-inq-row{
    display:block!important;min-width:0!important;padding:14px 16px!important;
  }
  .op-inq-row > div{margin-bottom:4px;}
  .op-inq-email,.op-inq-phone,.op-inq-message{display:none!important;}
  .op-inq-name{font-size:15px!important;font-weight:600!important;}
  .op-inq-date{font-size:11px!important;}
  .op-inq-status{flex-direction:row!important;flex-wrap:wrap;margin-bottom:0!important;}
}

/* ─── Kanban → tabs on mobile (3a) ────────────────────────────────────────
   Desktop: tabs hidden, kanban scrolls horizontally as multi-column board.
   Mobile: tab strip visible, kanban becomes a single-column list showing
           only the active status. */
.op-kanban-tabs{display:none;}
.op-kanban-tab{}
.op-kanban-col{}
@media(max-width:768px){
  .op-kanban-tabs{
    display:flex;gap:6px;overflow-x:auto;-webkit-overflow-scrolling:touch;
    padding-bottom:10px;margin-bottom:12px;border-bottom:1px solid var(--bo);
  }
  .op-kanban-tab{
    flex-shrink:0;display:inline-flex;align-items:center;gap:6px;
    padding:10px 14px;border:1px solid var(--bo);background:var(--bgc);
    border-radius:18px;font-family:'Inter',sans-serif;font-size:11px;font-weight:600;
    letter-spacing:0.15em;text-transform:uppercase;color:var(--txm);
    white-space:nowrap;min-height:40px;cursor:pointer;
  }
  .op-kanban-tab.active{
    background:var(--op-text-accent);color:#F8F4ED;border-color:var(--op-text-accent);
  }
  .op-kanban-tab-count{
    font-size:10px;padding:1px 6px;border-radius:8px;font-weight:700;letter-spacing:0.05em;
  }
  .op-kanban-board{flex-direction:column!important;overflow:visible!important;gap:0!important;}
  .op-kanban-col{display:none!important;}
  .op-kanban-col.mobile-active{
    display:block!important;width:100%!important;min-width:0!important;flex:1 1 auto!important;
  }
}

/* ─── PI/PL/PO list → stacked cards on mobile (3b) ─────────────────────────
   Hide the column-header row (useless when grid stacks); reformat each row
   into a vertical card with left-aligned cells. */
@media(max-width:768px){
  .op-doc-list-header{display:none!important;}
  .op-doc-list-row{
    grid-template-columns:1fr!important;gap:8px!important;padding:14px 16px!important;
    align-items:flex-start!important;
  }
  .op-doc-list-row > *{text-align:left!important;justify-content:flex-start!important;}
}

/* ─── Settings sidebar → horizontal scroll strip on mobile (3c) ───────────
   Desktop: 180px vertical sidebar + content. Mobile: top tab strip + full
   width content. */
@media(max-width:768px){
  .op-settings-shell{grid-template-columns:1fr!important;display:block!important;min-height:0!important;}
  .op-settings-nav{
    border-right:none!important;border-bottom:1px solid var(--bo);padding-top:0!important;
    display:flex!important;overflow-x:auto!important;-webkit-overflow-scrolling:touch;
    gap:4px;padding:8px 10px;
    position:sticky;top:60px;z-index:5;background:var(--bg);
  }
  .op-settings-nav-btn{
    width:auto!important;flex-shrink:0;padding:10px 14px!important;
    border:1px solid var(--bo)!important;border-radius:18px;font-size:11px!important;
    min-height:40px;white-space:nowrap;background:var(--bgc)!important;
  }
  .op-settings-nav-btn.active{
    background:var(--op-text-accent)!important;color:#F8F4ED!important;border-color:var(--op-text-accent)!important;
  }
  .op-settings-content{padding:16px!important;}
}

/* ─── Universal modal full-screen on mobile (Task 3 P4) ────────────────────
   Most admin modals use a fixed-position overlay with an inline-styled inner
   card. Detect typical modal patterns and full-screen them on phones. */
@media(max-width:768px){
  /* Overlay patterns — fixed inset:0 with high z-index */
  div[style*="position: fixed"][style*="inset"][style*="z-index"]{padding:0!important;}
  /* Modal card patterns — common props: maxWidth, borderRadius, padding */
  div[style*="position: fixed"][style*="inset"] > div[style*="maxWidth"],
  div[style*="position: fixed"][style*="inset"] > div[style*="max-width"],
  div[style*="position:fixed"][style*="inset"] > div[style*="max-width"]{
    width:100vw!important;max-width:none!important;height:100vh!important;max-height:none!important;
    border-radius:0!important;margin:0!important;overflow-y:auto!important;
  }
}

/* ─── P67 FINAL: touch targets (iPad, phones) ───────────────────────────────
   On a touch screen every tappable control is at least 44px tall. Mouse and
   trackpad layouts are unchanged. Checked by the layout audit (touch-target). */
@media (pointer: coarse){
  button, select, summary, [role="button"], [role="tab"], a.op-cat-btn, .op-cat-pill, .op-settings-nav-btn, a[data-tap],
  input:not([type="checkbox"]):not([type="radio"]):not([type="hidden"]):not([type="range"]):not([type="file"]):not([type="color"]){
    min-height:44px!important;
  }
  summary{display:flex;align-items:center;}
  [data-nav-dropdown] a{min-height:44px;}
  a.op-cat-btn, a[data-tap], a.op-settings-nav-btn{display:inline-flex;align-items:center;}
  input[type="checkbox"], input[type="radio"]{width:22px;height:22px;}
  label:has(> input[type="checkbox"]), label:has(> input[type="radio"]){min-height:44px;display:inline-flex;align-items:center;}
  input[type=range]{height:44px;background:linear-gradient(var(--bo),var(--bo)) center/100% 2px no-repeat;}
  input[type=range]::-webkit-slider-thumb{width:28px;height:28px;border-radius:50%;}
  input[type=range]::-moz-range-thumb{width:28px;height:28px;border-radius:50%;}
  .op-tap-tip{position:fixed;z-index:20000;max-width:min(320px,calc(100vw - 24px));background:#0A2416;color:#F8F4ED;font-family:'Inter',sans-serif;font-size:13px;line-height:1.45;text-transform:none;letter-spacing:normal;padding:8px 12px;border-radius:6px;box-shadow:0 8px 24px rgba(10,36,22,0.3);pointer-events:none;}
}
/* Top icons (search · showroom · settings · account): no hover on a touch
   screen, so each carries a visible caption there; the circle moves onto the
   glyph and the whole icon + caption is one 44px+ target. */
/* A small checkbox gets a 44px tap box on touch; the negative margin keeps
   the surrounding layout exactly as it was. */
.op-tap-box{display:inline-flex;align-items:center;justify-content:center;cursor:pointer;flex-shrink:0;}
@media (pointer: coarse){ .op-tap-box{width:44px;height:44px;margin:-14px;} }
.op-icon-glyph{display:inline-flex;align-items:center;justify-content:center;}
.op-icon-cap{display:none;}
@media (pointer: coarse){
  .op-icon-btn{width:auto!important;height:auto!important;min-width:44px;min-height:44px;border:none!important;border-radius:6px!important;background:transparent!important;display:inline-flex!important;flex-direction:column;align-items:center;justify-content:center;gap:2px;padding:0 2px!important;text-decoration:none;}
  .op-icon-btn .op-icon-glyph{width:36px;height:36px;border-radius:50%;border:1px solid var(--pr);box-sizing:border-box;}
  .op-icon-btn.op-icon-acct .op-icon-glyph{background:#1A3A2E;color:#C9A84C;border:none;font-family:'Cormorant Garamond',serif;font-size:18px;font-weight:600;}
  .op-icon-cap{display:block;font-family:'Inter',sans-serif;font-size:10px;font-weight:600;line-height:1.1;letter-spacing:0.02em;text-transform:none;color:var(--op-text-accent);white-space:nowrap;}
  .op-mobile-nav .op-icon-btn .op-icon-glyph{width:28px;height:28px;border:none;}
  .op-mobile-nav .op-icon-btn.op-icon-acct .op-icon-glyph{font-size:15px;}
}
`;


export { G };
